/**
 * Calculates the page number that should be sent with the request
 *
 * @param {number} params.numberOfRecords - The number of records per page
 * @param {number} params.pageSize - The amount of records reqested per page
 * @param {number} params.total - The total number of records
 *
 * @returns {number} The updated page number
 */

export function calculatePageNumber({numberOfRecords, pageSize, total}: any) {
  // if (pageSize > numberOfRecords) {
  //   return 1;
  // }

  // return Math.floor(numberOfRecords / pageSize) + 1;
  if (!pageSize || !total) {
    return;
  }

  if (numberOfRecords < pageSize) {
    return 1;
  }

  const totalPages = Math.ceil(total / pageSize);
  const currentPage = Math.ceil(numberOfRecords / pageSize);
  const nextPage = currentPage + 1;

  if (nextPage > totalPages) {
    return;
  }

  return nextPage;
}
